import React, { useEffect, useState, Fragment } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CouponUsageListAction } from "../../../../Redux/Actions/PaymentAction";
import { formatDate, calculateTotalPages } from "../../../../utils/Helper";
import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Pagination,
} from "@mui/material";
import Breadcrumb from "../../../DefaultComponent/BreadCrumb";
import Spinner from "../../../DefaultComponent/Spinner";
import ToastDefault from "../../../DefaultComponent/Toast";

const CouponUsage: React.FC = () => {
  const { coupon_id } = useParams<{ coupon_id: string }>();
  const dispatch = useDispatch<any>();

  const usageData = useSelector((state: any) => state.CouponUsageListData);

  const [usageList, setUsageList] = useState<any[]>([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const fetchUsage = (pageNum = page) => {
    setLoading(true);
    const params = `${coupon_id}/?page=${pageNum}&page_size=${rowsPerPage}`;
    dispatch(CouponUsageListAction(params));
  };

  useEffect(() => {
    fetchUsage();
  }, [dispatch, coupon_id, page]);

  useEffect(() => {
    if (usageData?.status) {
      setLoading(false);
      setUsageList(usageData.data.row);
      setCount(usageData.data.total_count);
    }
  }, [usageData]);

  return (
    <>
      {loading && <Spinner />}

      <div className="page-wrapper card" style={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{ p: 2 }}>
          <Breadcrumb
            pageTitle="Coupon Usage"
            breadcrumbs={[
              { label: "Coupons", path: "/payments/coupons", isActive: false },
              { label: "Usage", path: `/coupons/${coupon_id}/usage`, isActive: true },
            ]}
          />
        </Box>

        <Box sx={{ m: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="Coupon Usage Table">
              <TableHead sx={{ backgroundColor: "#0555c8" }}>
                <TableRow>
                  <TableCell align="center" sx={{ color: "white" }}>S.No</TableCell>
                  <TableCell align="center" sx={{ color: "white" }}>Transaction ID</TableCell>
                  <TableCell align="center" sx={{ color: "white" }}>Entity Type</TableCell>
                  <TableCell align="center" sx={{ color: "white" }}>Entity ID</TableCell>
                  <TableCell align="center" sx={{ color: "white" }}>Name</TableCell>
                  <TableCell align="center" sx={{ color: "white" }}>Email</TableCell>
                  <TableCell align="center" sx={{ color: "white" }}>Used At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {usageList.length > 0 ? (
                  usageList.map((u, idx) => (
                    <TableRow key={u.id}>
                      <TableCell align="center">
                        {(page - 1) * rowsPerPage + idx + 1}
                      </TableCell>
                      <TableCell align="center">{u.transaction_id}</TableCell>
                      <TableCell align="center">{u.entity_type}</TableCell>
                      <TableCell align="center">{u.entity_id}</TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                          <img
                            src={
                              u.user_data?.logo
                                ? u.user_data.logo
                                : u.org_data?.logo
                                ? u.org_data.logo
                                : "/default-profile-img.png"
                            }
                            alt="Profile"
                            style={{ width: 35, height: 35, borderRadius: "50%" }}
                          />
                          {u.user_data?.fullname ?? u.org_data?.org_name ?? "N/A"}
                        </Box>
                      </TableCell>
                      <TableCell align="center">{u.user_data?.email ?? u.org_data?.org_email}</TableCell>
                      <TableCell align="center">{formatDate(u.used_at)}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No usage found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
            <Stack spacing={2}>
              <Pagination
                count={calculateTotalPages(count, rowsPerPage)}
                page={page}
                onChange={(_, newPage) => setPage(newPage)}
                color="primary"
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </Box>
        </Box>
      </div>

      <ToastDefault />
    </>
  );
};

export default CouponUsage;